import { useRequest } from 'ahooks';
import {
  billDownloadService,
  billPaymentService,
  getBcareUserService,
  getBillService,
  getMonthService,
  getPaymentMothodService,
  getPaymentResultService,
  getPaymentService,
  getunPaymentService,
} from './services';

import {
  loginMessageService,
  loginMessageValidService,
} from '@/pages/Login/services';

import { getSystemParam } from '@/models/globalServices';

import { Base64 } from 'js-base64';
import moment from 'moment';
import { useState } from 'react';

export default function BillMgrModel() {
  // 下载文件后缀名称
  const date = new Date();
  const billDownLoadDate = moment(date).format('YYYY/MM/DD');

  const [treeSelectData, setTreeSelectData] = useState<any[]>([]);
  const [selectAcctValue, setSelectAcctValue] = useState<undefined>(undefined);
  const [paymentFailResult, setPaymentFailResult] = useState<any>({});
  const [postPaymentParams, setPostPaymentParams] = useState<any>({});
  const [errorFlag, setErrorFlag] = useState<boolean>(false);

  const {
    loading: queryBillLoading,
    data: billData,
    run: queryBillList,
    mutate: billMutate,
  } = useRequest(getBillService, {
    manual: true,
    onError: () => {
      setErrorFlag(true);
    },
    onSuccess: () => {
      setErrorFlag(false);
    },
  });

  const {
    loading: monthLoading,
    data: monthData,
    runAsync: queryMonthList,
    mutate: monthMutate,
  } = useRequest(getMonthService, {
    manual: true,
  });

  const { loading: payResultLoading, runAsync: queryPaymentResult } =
    useRequest(getPaymentResultService, {
      manual: true,
    });

  const { data: paymentMethodData, run: queryPaymentList } = useRequest(
    getPaymentMothodService,
    {
      manual: true,
    },
  );

  const { runAsync: queryVerificationCode } = useRequest(loginMessageService, {
    manual: true,
  });

  const { runAsync: queryBcareUser } = useRequest(getBcareUserService, {
    manual: true,
  });

  const { loading: payLoading, runAsync: submitBillPayment } = useRequest(
    billPaymentService,
    {
      manual: true,
    },
  );

  const { runAsync: validateVerificationCode } = useRequest(
    loginMessageValidService,
    {
      manual: true,
    },
  );

  const { loading: downLoading, runAsync: billDownload } = useRequest(
    billDownloadService,
    {
      manual: true,
    },
  );

  const { data: sysparamData, run: querySystemParam } = useRequest(
    getSystemParam,
    {
      manual: true,
    },
  );

  const {
    loading: isPaymentLoading,
    data: paymentData,
    runAsync: queryIsPayment,
  } = useRequest(getPaymentService, { manual: true });

  const { runAsync: queryUnPayment } = useRequest(getunPaymentService, {
    manual: true,
  });

  // 下载
  const onDownload = async () => {
    if (billData?.downLoadUrl) {
      const docId = Base64.encode(billData.downLoadUrl);
      const fileName = `BILL_${billData.billNbr}_${billDownLoadDate}.pdf`;
      await billDownload({
        docId,
        fileName,
      });
    }
  };

  return {
    queryBillList,
    queryMonthList,
    queryPaymentResult,
    queryPaymentList,
    queryBcareUser,
    queryVerificationCode,
    querySystemParam,
    queryIsPayment,
    queryUnPayment,
    submitBillPayment,
    billDownload,
    validateVerificationCode,
    onDownload,
    monthMutate,
    setTreeSelectData,
    setSelectAcctValue,
    billData,
    monthData,
    paymentData,
    sysparamData,
    monthLoading,
    payLoading,
    downLoading,
    payResultLoading,
    billDownLoadDate,
    paymentMethodData,
    queryBillLoading,
    isPaymentLoading,
    treeSelectData,
    selectAcctValue,
    paymentFailResult,
    setPaymentFailResult,
    postPaymentParams,
    setPostPaymentParams,
    errorFlag, 
    setErrorFlag,
    billMutate,
  };
}
